export const reduxKey: string = '@@firstTimeFlags';
export const localStorageKey: string = '@@firstTimeFlags';

export enum FirstTimeFlag {
  ProfileHeroAidNotClosed = 'isProfileHeroAidNotClosed',
  WelcomePopupNotClosed = 'isWelcomePopupNotClosed',
  IsJournalCoverNotUsed = 'isJournalCoverNotUsed',
  IsChatGeneralTabNotUsed = 'isChatGeneralTabNotUsed',
  IsNetworkbarGroupWatchNotUsed = 'isNetworkbarGroupWatchNotUsed',
  IsDevpageAddToGroupNotShown = 'isDevpageAddToGroupNotShown',
  IsNewNCHeaderNotAcknowledged = 'isNewNcHeaderNotAcknowledged',
  IsNewNCPageNotAcknowledged = 'isNewNcPageNotAcknowledged',
  IsBrowseSubscriptionsPromotionNotSeen = 'isBrowseSubscriptionsPromotionNotSeen',
  IsMsLockedArtNotSeen = 'isMsLockedArtNotSeen',
  IsMsSubscriptionNotPurchased = 'isMsSubscriptionNotPurchased',
  IsDyw3RemoveNotSeen = 'isDyw3RemoveNotSeen',
  IsDyw3WatchBannerNotSeen = 'isDyw3WatchBannerNotSeen',
  IsDyw3SubscriptionsFilterNotSeen = 'isDyw3SubscriptionsFilterNotSeen',
  IsMsFirstTierNotCreated = 'isMsFirstTierNotCreated',
  IsAppInstallCalloutNotClosed = 'isAppInstallCalloutNotClosed',
  IsAppInstallToastNotClosed = 'isAppInstallToastNotClosed',
  IsCustomboxNotDiscovered = 'isCustomboxNotDiscovered',
  IsDreamupPromptGuidelinesNotSeen = 'isDreamupPromptGuidelinesNotSeen',
}

export type FirstTimeFlagsType = {
  isProfileHeroAidNotClosed?: boolean;
  isWelcomePopupNotClosed?: boolean;
  isJournalCoverNotUsed?: boolean;
  isChatGeneralTabNotUsed?: boolean;
  isNetworkbarGroupWatchNotUsed?: boolean;
  isDevpageAddToGroupNotShown?: boolean;
  IsBrowseSubscriptionsPromotionNotSeen?: boolean;
  isMsLockedArtNotSeen?: boolean;
  isMsSubscriptionNotPurchased?: boolean;
  isDyw3RemoveNotSeen?: boolean;
  isDyw3WatchBannerNotSeen?: boolean;
  isDreamupPromptGuidelinesNotSeen?: boolean;
  IsDyw3SubscriptionsFilterNotSeen?: boolean;
  IsMsFirstTierNotCreated?: boolean;
  IsCustomboxNotDiscovered?: boolean;
};
